"use client";

import React, { useState, useEffect } from "react";
import {Modal} from "@mui/material";
import "react-international-phone/style.css"; 
import { getAllTags, getAllSources, addClient, applyTags } from "../../components/http";
import { useTranslation } from "react-i18next";
import TextInput from "../../components/inputs/TextInput";
import PhoneInputComponent from "../../components/inputs/PhoneInputComponent";
import SelectInput from "../../components/inputs/SelectInput";
import EmailInput from "../../components/inputs/EmailInput";
import ButtonsGroup from "../../components/PopUps/ButtonsGroup";
import styles from "./ClientPage.module.scss"

const ClientAddPopup = ({ open, onClose, onClientAdded }) => {
  const { t } = useTranslation("");
  const [clientData, setClientData] = useState({
    fullname: "",
    passport_number: "",
    phone_number: "",
    email: "",
    source: "",
    tags: [],
  });
  const [tags, setTags] = useState([]);
  const [sources, setSources] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFormData = async () => {
      try {
        const tagsData = await getAllTags();
        const sourcesData = await getAllSources();
        setTags(tagsData || []);
        setSources(sourcesData?.sources || []);
      } catch (error) {
        console.error(t("client.Add.errorFetchingData"), error);
      } finally {
        setLoading(false);
      }
    };

    fetchFormData();
  }, [t]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setClientData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePhoneChange = (phone) => {
    setClientData((prev) => ({ ...prev, phone_number: phone }));
  };

  const handleTagChange = (newTags) => {
    setClientData((prev) => ({
      ...prev,
      tags: newTags.map((tag) => ({
        id: tag.value,
        name: tag.label,
        colour: tag.colour || "#6b6b6b",
      })),
    }));
  };

  

  const handleSave = async () => {
    if (!clientData.fullname || !clientData.passport_number) {
      alert(t("client.Add.fillRequiredFields"));
      return;
    }
  
    try {
      const filteredClientData = Object.fromEntries(
        Object.entries(clientData).filter(([_, value]) => value !== "")
      );
  
      if (!filteredClientData.source) {
        filteredClientData.source = [];
      } else {
        filteredClientData.source = [filteredClientData.source];
      }
  
      const response = await addClient({
        ...filteredClientData,
        custom_params: {},
      });
  
      if (response?.client_id) {
        const clientId = response.client_id;
  
        if (filteredClientData.tags && filteredClientData.tags.length > 0) {
          await applyTags([
            {
              client_id: clientId,
              tags_ids: filteredClientData.tags.map((tag) => tag.id),
            },
          ]);
        }
  
        alert(t("client.Add.success"));
        onClientAdded();
        onClose();
      } else {
        alert(t("client.Add.errorAdding"));
      }
    } catch (error) {
      console.error(t("client.Add.errorSaving"), error);
      alert(t("client.Add.errorOccurred"));
    }
  };
  

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="client-add-popup-title"
      className={styles.modalContainer}
    >
    <div className={styles.modalContent}>
      <h2 className={styles.title}>{t("client.Add.title")}</h2>
  
        <div className={styles.inputsContainer}>

          <TextInput
            label={t("client.Add.fullName")}
            name="fullname"
            value={clientData.fullname}
            onChange={handleInputChange}
            placeholder={t("client.Add.fullName")}
            required={true}
          />

          <TextInput
            label={t("client.Add.passportNumber")}
            name="passport_number"
            value={clientData.passport_number}
            onChange={handleInputChange}
            placeholder={t("client.Add.passportNumber")}
            required={true}
          />

          <PhoneInputComponent
            label={t("client.Add.phoneNumber")}
            value={clientData.phone_number}
            onChange={handlePhoneChange}
            placeholder={t("client.Add.phoneNumber")}
          />

          <EmailInput
            label={t("client.Add.email")}
            name="email"
            value={clientData.email}
            onChange={handleInputChange}
            placeholder={t("client.Add.email")}
          />

          <SelectInput
            label={t("client.Add.source")}
            name="source"
            value={clientData.source}
            onChange={handleInputChange}
            options={sources}
          />
        
        </div>

        

          <ButtonsGroup
            onSave={handleSave}
            onCancel={onClose}
            saveText={t("client.Add.save")}
            cancelText={t("client.Add.cancel")}
          />
    </div>
  </Modal>
  );
};

export default ClientAddPopup;

